import { createTicket, apiConfigured } from '../api.js'
import {
  applyIssueToSubject,
  composeSubject,
  issueChipsHtml,
  SLA_HINT,
} from '../issueTypes.js'
import {
  clearFieldErrors,
  missingFieldsMessage,
  validateRequiredFields,
} from '../ui.js'
import { mountComposer, bindLightbox } from '../attachments.js'

const CREATE_PREFILL_KEY = 'portal_create_prefill'

export function renderCreate() {
  return `
    <div class="portal-card create-sheet">
      <div class="create-sheet-head">
        <div>
          <p class="portal-eyebrow">Paso 1 de 1</p>
          <h1>Cuéntanos qué ocurre</h1>
          <p class="portal-muted">Selecciona el tipo e indica tu empresa. Respuesta habitual en horario de contrato.</p>
        </div>
        <a href="/" data-link class="portal-btn">Volver</a>
      </div>
      <form id="create-form" class="create-form" novalidate>
        <input type="hidden" name="entry_mode" value="standard" />
        <div class="portal-field">
          <span class="portal-label">Tipo de incidencia</span>
          ${issueChipsHtml()}
        </div>
        <div class="portal-field">
          <label class="portal-label" for="company">Empresa *</label>
          <input class="portal-input" id="company" name="company" required autocomplete="organization" />
        </div>
        <div class="create-grid-2">
          <div class="portal-field">
            <label class="portal-label" for="requester_name">Tu nombre *</label>
            <input class="portal-input" id="requester_name" name="requester_name" required autocomplete="name" />
          </div>
          <div class="portal-field">
            <label class="portal-label" for="requester_email">Tu email *</label>
            <input class="portal-input" type="email" id="requester_email" name="requester_email" required autocomplete="email" />
          </div>
        </div>
        <div class="portal-field">
          <label class="portal-label" for="subject">Asunto *</label>
          <input class="portal-input" id="subject" name="subject" required maxlength="255" />
        </div>
        <div class="portal-field">
          <label class="portal-label" for="description">Descripción *</label>
          <textarea class="portal-textarea" id="description" name="description" required maxlength="10000"
            placeholder="Ej. El WiFi de la piscina no da cobertura desde las 18:00"></textarea>
        </div>
        <div class="portal-field">
          <label class="portal-label" for="priority">Prioridad</label>
          <select class="portal-select" id="priority" name="priority">
            <option value="low">Baja</option>
            <option value="medium" selected>Media</option>
            <option value="high">Alta</option>
            <option value="urgent">Urgente</option>
          </select>
        </div>
        <p class="create-sla">${SLA_HINT}</p>
        <div class="create-sticky">
          <button type="submit" class="portal-btn portal-btn-primary portal-btn-block">Enviar incidencia</button>
          <a href="/ia" data-link class="create-alt">o usar asistente IA</a>
        </div>
      </form>
      <p id="create-msg" class="portal-muted portal-form-msg" role="status"></p>
    </div>
  `
}

export function bindCreate(root, { navigate }) {
  const form = root.querySelector('#create-form')
  bindLightbox(root)
  const composer = form ? mountComposer(form) : null
  const msg = root.querySelector('#create-msg')
  const btn = form?.querySelector('button[type="submit"]')
  const subjectEl = form?.querySelector('#subject')

  try {
    const inviteRaw = sessionStorage.getItem('portal_invite_prefill')
    if (inviteRaw && form) {
      const prefill = JSON.parse(inviteRaw)
      sessionStorage.removeItem('portal_invite_prefill')
      if (prefill.company) form.company.value = prefill.company
      if (prefill.requester_name) form.requester_name.value = prefill.requester_name
      if (prefill.requester_email) form.requester_email.value = prefill.requester_email
    }
  } catch (_) {}

  try {
    const raw = sessionStorage.getItem(CREATE_PREFILL_KEY)
    if (raw && form) {
      const prefill = JSON.parse(raw)
      sessionStorage.removeItem(CREATE_PREFILL_KEY)
      if (prefill.description) form.description.value = prefill.description
      if (prefill.subject) form.subject.value = prefill.subject
    }
  } catch (_) {}

  applyIssueToSubject(form, subjectEl)
  form?.querySelectorAll('input[name="issue_type"]').forEach((el) => {
    el.addEventListener('change', () => applyIssueToSubject(form, subjectEl))
  })

  form?.querySelectorAll('input, textarea, select').forEach((el) => {
    el.addEventListener('input', () => {
      clearFieldErrors(el.closest('.portal-field') || form)
      msg.classList.remove('is-error')
    })
  })

  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    msg.classList.remove('is-error')
    if (!apiConfigured()) {
      msg.textContent = 'Servicio no disponible. Contacta por teléfono o email (pie de página).'
      msg.classList.add('is-error')
      return
    }

    if (subjectEl) {
      subjectEl.value = composeSubject(form, subjectEl, form.description)
    }

    const { ok, missing } = validateRequiredFields(form, [
      { name: 'company', label: 'Empresa' },
      { name: 'requester_name', label: 'Tu nombre' },
      {
        name: 'requester_email',
        label: 'Tu email',
        test: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
      },
      { name: 'subject', label: 'Asunto' },
      { name: 'description', label: 'Descripción' },
    ])
    if (!ok) {
      msg.textContent = missingFieldsMessage(missing)
      msg.classList.add('is-error')
      return
    }

    const fd = new FormData(form)
    fd.delete('issue_type')
    if (composer) {
      fd.delete('images[]')
      composer.appendToFormData(fd)
    }
    btn && (btn.disabled = true)
    msg.textContent = 'Enviando…'
    try {
      const data = await createTicket(fd)
      const path = data.ticket?.portal_path || `/t/${data.ticket?.access_token}`
      msg.textContent = data.message || 'Ticket creado.'
      navigate(path)
    } catch (e) {
      msg.textContent = e.message || 'Error al crear el ticket'
      msg.classList.add('is-error')
      btn && (btn.disabled = false)
    }
  })
}
